import { CartUpdateEvent, ThemeEvents } from '@theme/events';

// Keep the current theme's drawer, cart totals and icon in sync after gift changes.
document.addEventListener('tomo:cart-updated', (event) => {
  const cart = event.detail?.cart || event.detail;
  if (!cart || !Array.isArray(cart.items)) return;
  document.dispatchEvent(new CartUpdateEvent(cart, 'tomo-gift-chooser', {
    source: 'tomo-gift-chooser', itemCount: cart.item_count,
  }));
});

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  if (event.detail?.sourceId === 'tomo-gift-chooser') return;
  document.querySelectorAll('[data-tomo-gift-chooser][data-enabled="true"] [data-refresh]').forEach((button) => {
    if (!button.disabled) button.click();
  });
});
